import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import Tooltip from "../Tooltip";
import { useNavigate } from "react-router-dom";


const Table = ({ apiData, openLogs }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        item,
        name: getName(item),
        tenant: getTenantCount(item),
        moveout: getMoveOutTenantCount(item),
        collection: getCollection(item),
        previousCollection: getPreviousCollection(item),
        due: getDue(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //   const goToActiveLog = (item) => {
  //   navigate(`/activelogs/${item.clientId}`);
  // };

  const getName = (item) => {
    return (
      <div className="flex flex-col">
        <span className="text-gray-800 font-semibold">
          {item?.clientName || ""}
        </span>
      </div>
    );
  };
  const getTenantCount = (item) => {
    return (
      <div className="flex items-center">
        <span className="px-3 py-1 rounded-full bg-green-100 text-green-700 font-semibold text-xs cursor-pointer"
        //  onClick={(e) => goToActiveLog(item)}
         onClick={(e) => {
          e.stopPropagation();
          openLogs(item);
        }}
         >
          {item?.tenantAddedCount || 0}
        </span>
      </div>
    );
  };
  // const getCollection = (item) => {
  //   return (
  //     <div className="flex items-center">
  //       <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 font-semibold text-xs">
  //         ₹{item?.totalCollection || 0}
  //       </span>
  //     </div>
  //   );
  // };

  const getCollection = (item) => {
    const totalCollection = item?.totalCollection || 0;
    const onlineCollection = item?.onlineCollection || 0;
    const offlineCollection = item?.offlineCollection || 0;
    const content = (
      <div className="flex items-center">
        <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 font-semibold text-xs">
          ₹{totalCollection}
        </span>
      </div>
    );

    if (totalCollection) {
      return (
        <Tooltip
          label={
            <div className="text-xs leading-5">
              <div>Online Collection: ₹{onlineCollection}</div>
              <div>Offline Collection: ₹{offlineCollection}</div>
            </div>
          }
        >
         <div className="cursor-pointer">{content}</div>
        </Tooltip>
      );
    }
    return content;
  };

  const getPreviousCollection = (item) => {
    const totalCollection = item?.previousMonthCollection || 0;
    const onlineCollection = item?.previousMonthOnlineCollection || 0;
    const offlineCollection = item?.previousMonthOfflineCollection || 0;

    const content = (
      <div className="flex items-center">
        <span className="px-3 py-1 rounded-full bg-purple-100 text-purple-700 font-semibold text-xs">
          ₹{totalCollection}
        </span>
      </div>
    );

    if (totalCollection) {
      return (
        <Tooltip
          label={
            <div className="text-xs leading-5">
              <div>Online Collection: ₹{onlineCollection}</div>
              <div>Offline Collection: ₹{offlineCollection}</div>
            </div>
          }
        >
          <div className="cursor-pointer">{content}</div>
        </Tooltip>
      );
    }

    return content;
  };

  const getDue = (item) => {
    return (
      <div className="flex items-center">
        <span className="px-3 py-1 rounded-full bg-teal-100 text-teal-700 font-semibold text-xs">
          ₹{item?.dueAmount || 0}
        </span>
      </div>
    );
  };

  const getMoveOutTenantCount = (item) => {
    return (
      <div className="flex items-center">
        <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-700 font-semibold text-xs">
          {item?.moveOutCount || 0}
        </span>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Client Name",
          accessor: "name",
        },
        {
          Header: "Tenant",
          accessor: "tenant",
        },
      ];
    }
    return [
      {
        Header: "Client Name",
        accessor: "name",
      },
      {
        Header: "Tenant",
        accessor: "tenant",
      },
      {
        Header: "Move-Out",
        accessor: "moveout",
      },
      {
        Header: "Collection",
        accessor: "collection",
      },
      // {
      //   Header: "Previous",
      //   accessor: "previousCollection",
      // },
      {
        Header: "Dues",
        accessor: "due",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps()}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Collection:</strong>{" "}
                          {data[rowIndex].collection}
                        </li>
                        <li className="flex gap-2">
                          <strong>Due:</strong> {data[rowIndex].due}
                        </li>
                        <li className="flex gap-2">
                          <strong>Move Out:</strong> {data[rowIndex].moveout}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;

export default Table;
